import React from 'react'
import classes from './searchfilters.module.css'
import SearchFilterLoader from '../loaders/SearchFilterLoader'

const classVariants = {
    blue: classes.filterTypeActiveBlue,
    red: classes.filterTypeActiveRed,
}

const SearchFilters = ({
    header,
    filters,
    variants,
    onClick,
    activeId,
    isFetching,
}) => {
    if (isFetching) {
        return <SearchFilterLoader />
    }

    return (
        <div className={classes.filter}>
            <div className={classes.filterHeader}>{header}</div>
            <div className={classes.filterBody}>
                {filters.map(({ text, id }) => (
                    <button
                        className={[
                            classes.filterType,
                            activeId === String(id) && classes.filterTypeActive,
                            activeId === String(id) && classVariants[variants],
                        ].join(' ')}
                        onClick={() => onClick(id)}
                    >
                        <span className={classes.filterCheckbox} />
                        <span className={classes.filterTypeText}>{text}</span>
                    </button>
                ))}
            </div>
        </div>
    )
}

export default SearchFilters
